import script from "./purchase_view_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./purchase_view_btn.vue?vue&type=script&setup=true&lang=js"

import "./purchase_view_btn.vue?vue&type=style&index=0&id=11b9508e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b9508e"]])

export default __exports__